module.exports = __webpack_public_path__ + "img/Storage.5707ca4c.svg";